import React from 'react';
import { Box, Typography, Grid2, Paper, Button, useTheme, Icon } from '@mui/material';
import Section from './Section';

const SeccionPrimeraRifa = () => {
  const theme = useTheme();

  const rifaSteps = [
    { title: 'Haz clic en el botón (+)', description: 'Toca el botón flotante en la pantalla principal para iniciar.' },
    { title: 'Selecciona una imagen', description: 'Sube la foto del premio o portada de tu rifa desde tu galería.' },
    { title: 'Define la cantidad de boletos', description: 'Elige si será de 100, 1.000 o más números.' },
    { title: 'Título y descripción', description: 'Explica el motivo del sorteo de forma atractiva y clara.' },
    { title: 'Lotería oficial', description: 'Selecciona la lotería con la que jugará el sorteo.' },
    { title: 'Fecha y hora del sorteo', description: 'Establece el día y hora exactos del sorteo oficial.' },
    { title: 'Precio del boleto', description: 'Fija el valor unitario por cada número o fracción.' },
    { title: 'Premios a entregar', description: 'Detalla el premio mayor y posibles premios de consolación.' },
    { title: 'Métodos de pago', description: 'Indica los números de cuenta, Nequi, Daviplata o instrucciones.' },
  ];

  return (
    <Section
      title="Crea tu Primera Rifa"
      subtitle="Configura tu sorteo completo en sencillos pasos guiados desde la aplicación:"
      hasBackground={true}
      id="crea-tu-rifa"
    >
      <Grid2 container spacing={4} alignItems="center">
        {/* Pasos */}
        <Grid2 size={{ xs: 12, md: 8 }}>
          <Grid2 container spacing={2}>
            {rifaSteps.map((step, index) => (
              <Grid2 key={index} size={{ xs: 12, sm: 6 }}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 2,
                    height: '100%',
                    borderRadius: '12px',
                    bgcolor: theme.palette.background.paper,
                    border: theme.palette.mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.08)' : '1px solid rgba(0, 0, 0, 0.06)',
                    display: 'flex',
                    gap: 1.5,
                    alignItems: 'flex-start',
                    boxShadow: theme.palette.mode === 'dark' ? 'none' : '0 2px 6px rgba(26, 31, 82, 0.03)',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      borderColor: theme.palette.mode === 'dark' ? 'rgba(99, 102, 241, 0.4)' : 'rgba(45, 52, 132, 0.2)',
                      transform: 'translateY(-2px)',
                      boxShadow: theme.palette.mode === 'dark' ? '0 6px 16px rgba(0, 0, 0, 0.4)' : '0 6px 16px rgba(45, 52, 132, 0.06)',
                    },
                  }}
                >
                  {/* Badge numerado idéntico a rauh-rifas */}
                  <Box
                    sx={{
                      width: 28,
                      height: 28,
                      fontSize: '0.82rem',
                      fontWeight: 900,
                      bgcolor: theme.palette.mode === 'dark' ? 'rgba(99, 102, 241, 0.16)' : 'rgba(45, 52, 132, 0.08)',
                      color: theme.palette.mode === 'dark' ? '#818cf8' : theme.palette.primary.main,
                      borderRadius: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                      mt: 0.2,
                    }}
                  >
                    {index + 1}
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 800, color: theme.palette.text.primary, mb: 0.3 }}>
                      {step.title}
                    </Typography>
                    <Typography variant="caption" sx={{ color: theme.palette.text.secondary, lineHeight: 1.5, display: 'block' }}>
                      {step.description}
                    </Typography>
                  </Box>
                </Paper>
              </Grid2>
            ))}
          </Grid2>
        </Grid2>

        {/* Video Tutorial Card */}
        <Grid2 size={{ xs: 12, md: 4 }}>
          <Paper
            elevation={0}
            sx={{
              p: 3.5,
              borderRadius: '16px',
              bgcolor: theme.palette.background.paper,
              border: theme.palette.mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.08)' : '1px solid rgba(45, 52, 132, 0.1)',
              textAlign: 'center',
              boxShadow: theme.palette.mode === 'dark' ? '0 4px 20px rgba(0, 0, 0, 0.4)' : '0 4px 16px rgba(26, 31, 82, 0.04)',
            }}
          >
            <Box
              sx={{
                width: 52,
                height: 52,
                mx: 'auto',
                mb: 2,
                borderRadius: '12px',
                bgcolor: 'rgba(45, 52, 132, 0.08)',
                color: theme.palette.primary.main,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Icon sx={{ fontSize: 28, color: theme.palette.mode === 'dark' ? '#818cf8' : theme.palette.primary.main }}>smart_display</Icon>
            </Box>

            <Typography variant="h6" sx={{ fontWeight: 800, mb: 1, color: theme.palette.text.primary }}>
              Tutorial en Video
            </Typography>

            <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 3, lineHeight: 1.6 }}>
              Aprende cómo crear y personalizar tu primera rifa en menos de 2 minutos.
            </Typography>

            <Button
              variant="outlined"
              color="primary"
              size="large"
              fullWidth
              startIcon={<Icon>play_circle</Icon>}
              href="https://youtube.com/shorts/59r_p-i1r8w?si=7bE242W2c9zQ46qL"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                py: 1.2,
                fontWeight: 800,
                borderRadius: '8px',
                borderWidth: '1.5px',
                '&:hover': {
                  borderWidth: '1.5px',
                  bgcolor: 'rgba(45, 52, 132, 0.05)',
                },
              }}
            >
              Ver en YouTube
            </Button>
          </Paper>
        </Grid2>
      </Grid2>
    </Section>
  );
};

export default SeccionPrimeraRifa;